import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import FeaturedToursSection from "./sections/FeaturedToursSection";
import WhyChooseUsSection from "./sections/WhyChooseUsSection";
import Testimonials from "./sections/Testimonials";
import AboutSection from "./sections/AboutSection";
import ContactBooking from "./sections/ContactBooking";
import OurExperiences from "./sections/OurExperiences";
import FAQ from "./sections/FAQ";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <FeaturedToursSection />
      <WhyChooseUsSection />
      <Testimonials />
      <AboutSection />
      <ContactBooking />
      <OurExperiences />
      <FAQ />
      <Footer />
    </div>;
}